import React, { Component } from 'react';
import { Paper, Box, Typography, Button, Chip } from '@mui/material';
import { Event, Schedule, Edit, CheckCircle, Cancel } from '@mui/icons-material';

class ShopClosingCard extends Component {
    getOpeningTimeLeft() {
        const { endDate } = this.props;
        const _currentDate = new Date();

        const _timeDiff = new Date(endDate).valueOf() - _currentDate.valueOf();
        const _daysLeft = _timeDiff / (24 * 60 * 60 * 1000);

        if (_daysLeft >= 1) {
            return {
                text: `Noch ${_daysLeft.toFixed(0)} Tage offen`,
                isOpen: true
            };
        } else if (_daysLeft < 0) {
            return {
                text: `Der Shop ist geschlossen`,
                isOpen: false
            };
        } else {
            const hours = new Date(endDate).getHours();
            const minutes = new Date(endDate).getMinutes();
            return {
                text: `Noch heute offen bis ${hours}:${minutes < 10 ? "0" + minutes : minutes} Uhr`,
                isOpen: true
            };
        }
    }

    render() {
        const { startDate, endDate, isAdmin, onEdit } = this.props;
        const status = this.getOpeningTimeLeft();

        return (
            <Paper
                elevation={3}
                sx={{
                    flex: '1 1 300px',
                    minWidth: { xs: '100%', sm: '280px', md: '300px' },
                    width: { xs: '100%', sm: 'auto' },
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                        transform: { xs: 'none', sm: 'translateY(-2px)' }
                    }
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #81c784 0%, #a5d6a7 100%)',
                        p: { xs: 1.2, sm: 1.5 },
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: { xs: 0.8, sm: 1 }
                    }}
                >
                    <Event sx={{ fontSize: { xs: '1.1rem', sm: '1.3rem' } }} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, fontSize: { xs: '0.85rem', sm: '0.95rem' } }}>
                        Bestellzeitraum
                    </Typography>
                </Box>

                <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                    {/* Date Info */}
                    <Box sx={{ mb: 1.5 }}>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: '#666',
                                fontWeight: 500,
                                lineHeight: 1.5,
                                fontSize: '0.85rem'
                            }}
                        >
                            {new Date(startDate).toLocaleDateString('de-DE', { 
                                day: '2-digit', 
                                month: 'short'
                            })} - {new Date(endDate).toLocaleDateString('de-DE', { 
                                day: '2-digit', 
                                month: 'short',
                                year: 'numeric' 
                            })}
                        </Typography>
                    </Box>

                    {/* Status Badge */}
                    <Box sx={{ mb: 1.5 }}>
                        <Chip
                            icon={status.isOpen ? <CheckCircle /> : <Cancel />}
                            label={status.text}
                            size="small"
                            sx={{
                                width: '100%',
                                py: 1.2,
                                height: 'auto',
                                fontSize: '0.85rem',
                                fontWeight: 600,
                                bgcolor: status.isOpen ? '#e8f5e9' : '#ffebee',
                                color: status.isOpen ? '#2e7d32' : '#c62828',
                                border: `1.5px solid ${status.isOpen ? '#81c784' : '#ef5350'}`,
                                '& .MuiChip-icon': {
                                    fontSize: '1.1rem',
                                    color: status.isOpen ? '#2e7d32' : '#c62828'
                                }
                            }}
                        />
                    </Box>

                    {/* Edit Button for Admin */}
                    {isAdmin && (
                        <Button 
                            variant="outlined"
                            fullWidth
                            size="small"
                            startIcon={<Edit />}
                            onClick={onEdit}
                            sx={{
                                borderColor: '#81c784',
                                color: '#2e7d32',
                                fontWeight: 600,
                                textTransform: 'none',
                                borderRadius: '8px',
                                py: 0.5,
                                fontSize: '0.85rem',
                                '&:hover': {
                                    borderColor: '#66bb6a',
                                    bgcolor: '#f1f8e9'
                                }
                            }}
                        >
                            Ändern
                        </Button>
                    )}
                </Box>
            </Paper>
        );
    }
}

export default ShopClosingCard;
